<action class="w-12 button p-r-0-s p-l-0-s"
        [class.is-disabled]="isDisabled || !isSalable"
        [status]="status"
        (click)="buyGiftcard()">
    {{(isSalable ? 'Add to basket' : 'Out of stock') | translate }}
</action>
<result class="block"
        [status]="status"></result>
